/**
 * Parts states
 * Sta
 */

const partStates = {};
// Speaker units
partStates.speakers = {};
partStates.speakers.front = {
  a: {
    on: {
      translateX: 0,
      translateY: 0,
    },
    off: {
      translateX: "15%",
      translateY: "30%",
    },
    out: {
      translateX: "30%",
      translateY: "60%",
      duration: 300,
    },
  },
  b: {
    on: {
      translateX: 0,
      translateY: 0,
    },
    off: {
      translateX: "-15%",
      translateY: "30%",
    },
    out: {
      translateX: "-30%",
      translateY: "60%",
      duration: 300,
    },
  },
};
partStates.speakers.side = {
  a: {
    on: {
      translateX: 0,
      translateY: 0,
    },
    off: {
      translateX: 0,
      translateY: "30%",
      duration: 200,
    },
    out: {
      translateX: 0,
      translateY: "100%",
      duration: 400,
    },
  },
  b: {
    on: {
      translateX: 0,
      translateY: 0,
    },
    off: {
      translateX: 0,
      translateY: "30%",
      duration: 200,
    },
    out: {
      translateX: 0,
      translateY: "100%",
      duration: 400,
    },
  },
};

// Headband
partStates.headband = {};
partStates.headband.front = {
  a: {
    on: {
      translateX: 0,
      translateY: 0,
      opacity: 1,
    },
    off: {
      translateX: 0,
      translateY: "-10%",
      opacity: 0,
    },
    out: {
      translateX: 0,
      translateY: "100%",
      duration: 300,
      opacity: 1,
    },
  },
};
partStates.headband.side = {
  a: {
    on: {
      translateX: 0,
      translateY: 0,
      opacity: 1,
    },
    off: {
      translateX: 0,
      translateY: "-10%",
      duration: 200,
      opacity: 0,
    },
    out: {
      translateX: 0,
      translateY: "100%",
      duration: 400,
      opacity: 1,
    },
  },
};

// Earpads
partStates.earpads = {};
partStates.earpads.front = {
  a: {
    on: {
      translateX: 0,
      translateY: 0,
    },
    off: {
      translateX: "6%",
      translateY: "-3%",
    },
    off2: {
      translateX: "15%",
      translateY: "30%",
    },
    out: {
      translateX: "30%",
      translateY: "60%",
      duration: 300,
    },
  },
  b: {
    on: {
      translateX: 0,
      translateY: 0,
    },
    off: {
      translateX: "-6%",
      translateY: "-3%",
    },
    off2: {
      translateX: "-15%",
      translateY: "30%",
    },
    out: {
      translateX: "-30%",
      translateY: "60%",
      duration: 300,
    },
  },
};
partStates.earpads.side = {
  a: {
    on: {
      translateX: 0,
      translateY: 0,
      scale: 1,
    },
    off: {
      translateX: 0,
      translateY: 0,
      scale: 0.95,
      duration: 150,
    },
    off2: {
      translateX: 0,
      translateY: "30%",
      scale: 1,
      duration: 200,
    },
    out: {
      translateX: 0,
      translateY: "100%",
      scale: 1,
      duration: 400,
    },
  },
};

// Cable
partStates.cable = {};
partStates.cable.front = {
  a: {
    on: {
      translateX: 0,
      translateY: 0,
    },
    off: {
      translateX: "15%",
      translateY: "30%",
    },
    out: {
      translateX: "30%",
      translateY: "60%",
      duration: 300,
    },
  },
};
partStates.cable.side = {
  a: {
    on: {
      translateX: 0,
      translateY: 0,
    },
    off: {
      translateX: 0,
      translateY: "30%",
      duration: 200,
    },
    out: {
      translateX: 0,
      translateY: "100%",
      duration: 400,
    },
  },
};

export default partStates;
